var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureIconRegistration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4239_220)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#E0F2FE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4239_220)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4239_220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.406 32.132L32.586 37.187C32.5128 37.2206 32.4508 37.2744 32.4074 37.3422C32.364 37.41 32.341 37.4888 32.3411 37.5693C32.3412 37.6498 32.3644 37.7286 32.408 37.7963C32.4516 37.8639 32.5137 37.9176 32.587 37.951L43.492 42.969C43.814 43.117 44.186 43.117 44.508 42.969L55.413 37.951C55.4863 37.9177 55.5485 37.8641 55.5922 37.7965C55.6359 37.7289 55.6592 37.6502 55.6594 37.5697C55.6596 37.4892 55.6367 37.4103 55.5934 37.3425C55.55 37.2746 55.4881 37.2207 55.415 37.187L44.594 32.132C44.408 32.0451 44.2053 32.0001 44 32.0001C43.7947 32.0001 43.592 32.0451 43.406 32.132Z",
    fill: "#0876DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.415 43.676L53.18 42.632C53.0199 42.5572 52.8455 42.5182 52.6688 42.5177C52.4922 42.5172 52.3175 42.5552 52.157 42.629L44.508 46.149C44.3487 46.2223 44.1754 46.2602 44 46.2602C43.8246 46.2602 43.6513 46.2223 43.492 46.149L35.842 42.629C35.6816 42.5553 35.5072 42.5174 35.3307 42.5179C35.1542 42.5185 34.9799 42.5574 34.82 42.632L32.585 43.676C32.5119 43.7097 32.45 43.7636 32.4066 43.8315C32.3633 43.8993 32.3404 43.9782 32.3406 44.0587C32.3408 44.1392 32.3641 44.2179 32.4078 44.2855C32.4515 44.3531 32.5137 44.4067 32.587 44.44L43.492 49.457C43.6512 49.5307 43.8246 49.5688 44 49.5688C44.1754 49.5688 44.3488 49.5307 44.508 49.457L55.413 44.44C55.4863 44.4067 55.5485 44.3531 55.5922 44.2855C55.6359 44.2179 55.6592 44.1392 55.6594 44.0587C55.6596 43.9782 55.6367 43.8993 55.5934 43.8315C55.55 43.7636 55.4881 43.7097 55.415 43.676Z",
    fill: "#0876DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.415 50.108L53.18 49.064C53.02 48.9892 52.8455 48.9502 52.6688 48.9497C52.4922 48.9492 52.3175 48.9872 52.157 49.061L44.508 52.58C44.3487 52.6533 44.1754 52.6912 44 52.6912C43.8246 52.6912 43.6514 52.6533 43.492 52.58L35.842 49.06C35.6817 48.9863 35.5072 48.9484 35.3307 48.9489C35.1542 48.9494 34.9799 48.9884 34.82 49.063L32.585 50.108C32.5122 50.1418 32.4505 50.1957 32.4074 50.2634C32.3643 50.3312 32.3415 50.4098 32.3417 50.4901C32.3419 50.5704 32.3651 50.649 32.4086 50.7165C32.4521 50.784 32.514 50.8376 32.587 50.871L43.492 55.889C43.814 56.037 44.186 56.037 44.508 55.889L55.413 50.871C55.486 50.8376 55.548 50.784 55.5914 50.7165C55.6349 50.649 55.6581 50.5704 55.6584 50.4901C55.6586 50.4098 55.6358 50.3312 55.5926 50.2634C55.5495 50.1957 55.4879 50.1418 55.415 50.108Z",
    fill: "#0876DD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4239_220",
    x: -8,
    y: 2,
    width: 104,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.172549 0 0 0 0 0.25098 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4239_220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4239_220",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4239_220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4239_220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(32 32)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIconRegistration);
export default __webpack_public_path__ + "static/media/feature-icon-registration.e55a67e83f111297b600edb685de0505.svg";
export { ForwardRef as ReactComponent };